import { unref, toRefs, computed } from 'vue';
import {
    parse, format, differenceInDays, differenceInMonths, startOfDay, startOfMonth,
} from 'date-fns';
import { ru } from 'date-fns/locale';

import { RailwayDirection } from '@ve/types/railway/RailwayDirection';
import { RailwayLeg } from '@ve/types';

import { IRailwayToursListItem } from './types';

export default (props: {
    railwayTourItem: IRailwayToursListItem
}) => {
    const {
        railwayTourItem,
    } = toRefs(props);

    const _departureDate = (direction: RailwayDirection<RailwayLeg> | null) => (direction ? parse(direction.legs[0].departureDate, 'yyyy-MM-dd HH:mm:ss', new Date()) : null);
    const _arrivalDate = (direction: RailwayDirection<RailwayLeg> | null) => (direction ? parse(direction.legs[direction.legs.length - 1].arrivalDate, 'yyyy-MM-dd HH:mm:ss', new Date()) : null);

    const _departureDateThere = computed(() => _departureDate(unref(railwayTourItem).routes?.[0].there || null));
    const _arrivalDateThere = computed(() => _arrivalDate(unref(railwayTourItem).routes?.[0].there || null));

    const _departureDateBack = computed(() => _departureDate(unref(railwayTourItem).routes?.[0].back || null));
    const _arrivalDateBack = computed(() => _arrivalDate(unref(railwayTourItem).routes?.[0].back || null));

    const _datesCommonText = (departureDateThere: Date | null, arrivalDateThere: Date | null) => {
        if (departureDateThere && arrivalDateThere) {
            if (!differenceInDays(startOfDay(departureDateThere), startOfDay(arrivalDateThere))) {
                return format(departureDateThere, 'd MMMM', { locale: ru });
            }

            if (!differenceInMonths(startOfMonth(departureDateThere), startOfMonth(arrivalDateThere))) {
                return `${format(departureDateThere, 'd', { locale: ru })}–${format(arrivalDateThere, 'd MMMM', { locale: ru })}`;
            }

            return `${format(departureDateThere, 'd MMM', { locale: ru })} – ${format(arrivalDateThere, 'd MMM', { locale: ru })}`;
        }

        return '';
    };

    const _dateText = (date: Date | null) => (date ? format(date, 'dd.MM', { locale: ru }) : '');

    const thereDateCommon = computed(() => _datesCommonText(unref(_departureDateThere), unref(_arrivalDateThere)));
    const departureDateThereText = computed(() => _dateText(unref(_departureDateThere)));
    const arrivalDateThereText = computed(() => _dateText(unref(_arrivalDateThere)));

    const backDateCommon = computed(() => _datesCommonText(unref(_departureDateBack), unref(_arrivalDateBack)));
    const departureDateBackText = computed(() => _dateText(unref(_departureDateBack)));
    const arrivalDateBackText = computed(() => _dateText(unref(_arrivalDateBack)));

    const checkInOutDateCommon = computed(() => _datesCommonText(unref(railwayTourItem).checkInDate, unref(railwayTourItem).checkOutDate));
    const checkInDate = computed(() => _dateText(unref(railwayTourItem).checkInDate));
    const checkOutDate = computed(() => _dateText(unref(railwayTourItem).checkOutDate));

    return {
        thereDateCommon,
        departureDateThereText,
        arrivalDateThereText,

        backDateCommon,
        departureDateBackText,
        arrivalDateBackText,

        checkInOutDateCommon,
        checkInDate,
        checkOutDate,
    };
};